import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the PosServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PosServiceProvider {

  constructor(public http: HttpClient) {
    console.log('Hello PosServiceProvider Provider');
  }
  loadPOSDashboard(userid, token, serverlocation, kodediv, groupid = 0) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "KodeDiv": kodediv,
        "GroupID": groupid.toString()
      })
    };
    var url = serverlocation + '/dashboard/postable';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadPOSDashboardGroup(userid, token, serverlocation, kodediv) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "KodeDiv": kodediv
      })
    };
    var url = serverlocation + '/dashboard/postablegroup';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  getDateServer(userid, token, serverlocation) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token
      })
    };
    var url = serverlocation + '/dashboard/getdateserver';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }
  
  loadPOSRunningTimer(userid, token, serverlocation) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token
      })
    };
    var url = serverlocation + '/dashboard/posrunningtimer';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadPOSRunning(userid, token, serverlocation, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/posrunning';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadPOSPaid(userid, token, serverlocation, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno":icno
      })
    };
    var url = serverlocation + '/dashboard/pospaid';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }
  loadPOSCanceled(userid, token, serverlocation, icno) {


    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/poscanceled';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadPOSSale(userid, token, serverlocation, ondate, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "ondate": ondate,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/possale';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadPOSSaleItem(userid, token, serverlocation, icno, dateFrom, dateTo, kodeDiv?) {

    let headers: any = {
      'Content-Type': 'application/json',
      'Client-Service': 'insoft-client',
      'Auth-Key': 'insoftmobile',
      "User-ID": userid,
      "Authorization": token,
      "icno": icno,
      "dateFrom": dateFrom,
      "dateTo": dateTo
    };
    if (kodeDiv) {
      headers['kodeDiv'] = kodeDiv;
    }

    let httpOptions = { headers: new HttpHeaders(headers) };
    var url = serverlocation + '/dashboard/pos_sale_item';

    return new Promise((resolve, reject) => {
      this.http.get(url, httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  loadPOSSaleStatistic(userid, token, serverlocation, icno, dateFrom, dateTo, kodeDiv?) {

    let headers: any = {
      'Content-Type': 'application/json',
      'Client-Service': 'insoft-client',
      'Auth-Key': 'insoftmobile',
      "User-ID": userid,
      "Authorization": token,
      "icno": icno,
      "dateFrom": dateFrom,
      "dateTo": dateTo
    };
    if (kodeDiv) {
      headers['kodeDiv'] = kodeDiv;
    }

    let httpOptions = { headers: new HttpHeaders(headers) };
    var url = serverlocation + '/dashboard/pos_sale_statistic';

    return new Promise((resolve, reject) => {
      this.http.get(url, httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
      });
    });
  }

  loadPOSStatus(userid, token, serverlocation, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/posstatus';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadOutlet(userid, token, serverlocation, icno) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "icno": icno
      })
    };
    var url = serverlocation + '/pos/listoutletds';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }

  loadPOSChart(userid, token, serverlocation, icno, ondate = '') {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Client-Service': 'insoft-client',
        'Auth-Key': 'insoftmobile',
        "User-ID": userid,
        "Authorization": token,
        "ondate": ondate,
        "icno": icno
      })
    };
    var url = serverlocation + '/dashboard/get_dash_chartpos';

    return new Promise(resolve => {
      this.http.get(url,httpOptions).subscribe(data => {
        resolve(data);
      }, err => {
        console.log(err);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/pos-service/pos-service.ts